import invoiceService from "../services/InvoiceService";
import {
  getOrderIdForTransaction,
  loadActivePaymentSession,
} from "./abandonedOrderPayments";
import { loadHeldCheckoutOrder } from "./checkoutSession";

/** Resolve checkout order id from held session, txn link, or active payment session. */
export function resolveCheckoutOrderId(transactionId?: string | null): string | null {
  const held = loadHeldCheckoutOrder();
  if (held?.orderId) return held.orderId;

  const tx = String(transactionId ?? "").trim();
  if (tx) {
    const linked = getOrderIdForTransaction(tx);
    if (linked) return linked;
  }

  const session = loadActivePaymentSession();
  if (session?.orderId) return session.orderId;

  return null;
}

export async function isCheckoutOrderPaid(orderId: string): Promise<boolean> {
  try {
    const res = await invoiceService.getOrderPaymentSummary(orderId);
    const data = (res.data ?? {}) as {
      paymentStatus?: string;
      remainingAmount?: number;
    };
    const status = String(data.paymentStatus ?? "").toUpperCase();
    const remaining = Number(data.remainingAmount);

    const paidStatus =
      status.includes("PAID") ||
      status.includes("SUCCESS") ||
      status.includes("COMPLETED");
    if (!paidStatus || status.includes("PARTIAL") || status.includes("UNPAID")) {
      return false;
    }
    if (Number.isFinite(remaining) && remaining > 0.01) return false;
    return true;
  } catch {
    return false;
  }
}

/** When the gateway session is stale but the order was fulfilled server-side. */
export async function tryResolvePaidCheckout(
  transactionId?: string | null
): Promise<{ paid: boolean; orderId: string | null }> {
  const orderId = resolveCheckoutOrderId(transactionId);
  if (!orderId) return { paid: false, orderId: null };
  const paid = await isCheckoutOrderPaid(orderId);
  return { paid, orderId };
}
